import { render, staticRenderFns } from "./RemoteFolderConfigurationPage.vue?vue&type=template&id=295a0734&"
import script from "./RemoteFolderConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./RemoteFolderConfigurationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295a0734')) {
      api.createRecord('295a0734', component.options)
    } else {
      api.reload('295a0734', component.options)
    }
    module.hot.accept("./RemoteFolderConfigurationPage.vue?vue&type=template&id=295a0734&", function () {
      api.rerender('295a0734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/RemoteFolderConfigurationPage.vue"
export default component.exports